import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { IconContext } from "react-icons";
import { BsFillPencilFill } from "react-icons/bs";
import FService from "../Services/CatProductos.Services";
import { ICatProducto } from "../Interfaces/ICatProducto";
import { MsgInformativo } from "../../Utils/Toast/msgInformativo";

type Props = {};

export default function CatProductos({}: Props) {
    const [mProfile, setProfile] = useState(() => {
    const stickyValue = window.localStorage.getItem('Perfil')
    return stickyValue !== null ? JSON.parse(stickyValue) : ''
  })
  const [ID, setID] = useState(0);
  const [CatProductos, setCatProductos] = useState<ICatProducto[]>([]);
  const [Codigo, setCodigo] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [Buscar, setBuscar] = useState("");
  const [show, setShowMsg] = useState(false);
  const [ShowModal, setShowModal] = useState(false);
  const [header, setHeader] = useState("");
  const [msg, setMsg] = useState("");
  const [msgColor, setMsgColor] = useState("primary");
  const [Activo, setActivo] = useState(false);
  const colData = [
    {
      name: "id",
      width: "5%",
      selector: (row: ICatProducto) => row.id,
      sortable: true,
    },
    {
      name: "Codigo",
      width: "10%",
      selector: (row: ICatProducto) => row.codigo,
    },
    {
      name: "Descripcion",
      width: "70%",
      selector: (row: ICatProducto) => row.descripcion,
    },
    {
      name: "Edita",
      cell: (row: ICatProducto) => (
        <div
          style={{
            textAlign: "center",
            cursor: "pointer",
            visibility: mProfile === "Administrador" ? "visible" : "hidden",
          }}
          onClick={() => {
            console.log(row);
            setID(row.id);
            setCodigo(row.codigo);
            setDescripcion(row.descripcion);
            setActivo(row.activo);
          }}
        >
          <IconContext.Provider value={{ color: "blue", size: "25px" }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
    },
    {
      name: "Activo",
      cell: (row: ICatProducto) => (
        <div style={{ textAlign: "center", cursor: "pointer" }}>
          <Form.Check
            type="switch"
            id="custom-switch"
            label=""
            checked={row.activo}
            onClick={() => {
              //save(row.id, row.descripcion, !row.activo);
              ToggleProducto(row.id);
            }}
            style={{}}
          />
        </div>
      ),
    },
  ];

  const saveProducto = () => {
    if (Codigo.length < 5) {
      setHeader("Error");
      setMsg("El código debe tener al menos 5 caracteres.");
      setShowMsg(true);
      return;
    }
    if (Descripcion.length < 10) {
      setHeader("Error");
      setMsg("La descripción debe tener al menos 10 caracteres.");
      setShowMsg(true);
      return;
    }
    const data: ICatProducto = {
      id: ID,
      codigo: Codigo,
      descripcion: Descripcion,
      activo: true,
    };
    FService.Append(data)
      .then((response) => {
        console.log(response.data);
        setCatProductos(response.data);
        loadCatProductos();
        setID(0);
        setCodigo("");
        setDescripcion("");
      })
      .catch((e: Error) => {
        setHeader("Error");
        setMsg("Ocurrio un error: " + e);
        setShowMsg(true);
        return;
      });
  };

  const ClearFields = () => {
    setID(0);
    setCodigo("");
    setDescripcion("");
    setActivo(false);
  };

  const loadCatProductos = () => {
    FService.Get()
      .then((response) => {
        console.log(response.data);
        setCatProductos(response.data);
      })
      .catch((e: Error) => {
        setHeader("Error");
        setMsg("Ocurrio un error: " + e);
        setShowMsg(true);
        return;
      });
  };

  const ToggleProducto = (id: number) => {
    FService.Toggle(id)
      .then((response) => {
        loadCatProductos();
      })
      .catch((e: Error) => {
        setHeader("Error");
        setMsg("Ocurrio un error: " + e);
        setShowMsg(true);
        return;
      });
  };

  useEffect(() => {
    loadCatProductos();
  }, []);

  return (
    <div>
      <Row style={{ marginTop: "20px" }}>
        <Col xs={2}></Col>
        <Col xs={8}>
          <Card style={{ width: "100%" }}>
            <Card.Body>
              <Card.Text>
                <Row>
                  <Col xs={1}>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Id"
                      className="mb-3"
                    >
                      <Form.Control
                        type="number"
                        placeholder=""
                        value={ID}
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={2}>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Codigo"
                      className="mb-3"
                    >
                      <Form.Control
                        type="number"
                        placeholder="Codigo"
                        value={Codigo}
                        onChange={(e) => setCodigo(e.target.value)}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={7}>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Descripcion"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Descripcion"
                        value={Descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={1}>
                    <span
                      className="material-symbols-light--rectangle-add-rounded"
                      title="Guardar"
                      style={{ cursor: "pointer" }}
                      onClick={() => saveProducto()}
                    ></span>
                  </Col>
                  <Col xs={1}>
                    <span
                      className="solar--eraser-bold-duotone"
                      title="Borrar"
                      onClick={() => {
                        ClearFields();
                      }}
                      style={{ cursor: "pointer" }}
                    ></span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <DataTable
                      noHeader
                      defaultSortFieldId={"id"}
                      defaultSortAsc={true}
                      pagination
                      highlightOnHover
                      columns={colData}
                      data={CatProductos.length > 0 ? CatProductos : []}
                    />
                  </Col>
                </Row>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={2}></Col>
      </Row>
      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        time={2000}
        msgColor={msgColor}
        closeToast={() => {
          setShowMsg(false);
        }}
      />
    </div>
  );
}
